export default class HitAreaUtil {
    /**
     * Create a new square shape respecting the given bounds or bounds of the display object and applies that shape as the hit area.
     * @param {createjs.DisplayObject} displayObject 
     * @param {createjs.Rectangle} overrideBounds 
     */
    static applySquareHitArea(displayObject, overrideBounds = null) {
        const bounds = overrideBounds || displayObject.getBounds() || displayObject.nominalBounds;
        if (bounds === undefined || bounds === null) {
            console.warn(`[HitAreaUtil] applySquareHitArea - Display object has no bounds. Ignoring request...`);
        }

        const shape = new createjs.Shape();
        shape.graphics.beginFill(`#F00`)
            .drawRect(bounds.x, bounds.y, bounds.width, bounds.height);

        displayObject.hitArea = shape;
    }
}